import Vue from "vue";
import VueEvents from "./vue-events";
import VueI18n from "vue-i18n";

import NavigationBar from "../components/NavigationBar.vue";
import Hero from "../components/Hero.vue";
import YetiMap from "../components/YetiMap.vue";
import InstagramFeed from "../components/InstagramFeed.vue";
import SocialMedias from "../components/SocialMedias.vue";
import CtaButton from "../components/CtaButton.vue";

import ContestRulesEn from "../assets/pdf/contest-rules.pdf";
import ContestRulesFr from "../assets/pdf/reglement-de-participation.pdf";

Vue.use(VueI18n);

const messages = {
  en: {
    navigationBar: {
      title: "A Yetirific Contest",
      backToTop: "Back to top",
      niceToMentosYou: "Find a Yeti",
      goToMentos: "Go to mentos.ca",
      goToMentosUrl: "http://www.mentos.ca/en",
      language: "Français"
    },

    hero: {
      title: "Win a chewrific* amount<br/>of gum and $1,000",
      text: "*That’s yeti for 1,000 bottles of gum.",
      contestEndtitle: "We made over 1,000<br/>chewrific new friends!",
      contestEndtext: "We’ll be back soon with your yetirific winner",
      winnerTitle: "Oh hey! Meet Ingrid, the proud<br/>new owner of 50,000 pieces of<br/>Mentos Pure Fresh gum!",
      winnerText: "Maybe she’ll share a gum or two.",
    },

    steps: {
      firstStepTitle: "Step 1.",
      firstStepText: "Find a yeti",
      secondStepTitle: "Step 2.",
      secondStepText: "Take a picture",
      thirdStepTitle: "Step 3.",
      thirdStepText: "Share it on Instagram with #hellofreshness",
    },

    findAYeti: "Find a Yeti",

    termsAndConditionsLabel: "Terms and conditions",

    termsAndConditionsUrl: "/dist/contest-rules.pdf",

    winnerName: "Ingrid",

    winnerBio: "I'd like to thank Mentos for sponsoring my fresh breath for the rest of my McGill career and for the rest of my life, probably. #hellofreshness<br/><br/>Thank you so much for everything &#9786;",

    getToKnowUs: "Get to know us",

    niceToMentosYou: "Nice to mentos you",

    helloFreshness: "#hellofreshness",

    instagramFeedError: "No images can be fetched for the moment.",

    instagramFeedLoadMore: "Load more",

    footer: {
      contactUsLabel: "Contact us",
      contactUsUrl: "http://www.mentos.ca/en/contact-us",
      termesOfUseLabel: "Terms of use",
      termesOfUseUrl: "http://www.mentos.ca/en/terms-use",
      faqLabel: "FAQ",
      faqUrl: "http://www.mentos.ca/en/faq",
      countriesLabel: "Countries",
      countriesUrl: "http://countries.mentos.com",
    }
  },

  fr: {
    navigationBar: {
      title: "Un concours yétilarant",
      backToTop: "Haut de la page",
      niceToMentosYou: "Trouver un yéti",
      goToMentos: "Aller à mentos.ca",
      goToMentosUrl: "http://www.mentos.ca/fr",
      language: "English"
    },

    hero: {
      title: "Une montagne de gomme*<br/>et 1 000 $ à gagner",
      text: "* Équivalent yéti de 1 000 bouteilles de gomme.",
      contestEndtitle: "On a plus de 1 000 nouveaux<br/>amis gommidables!",
      contestEndtext: "Le nom de notre gagnant sera annoncé sous peu",
      winnerTitle: "Hey! Voici Ingrid, nouvellement<br/>propriétaire de 50 000 morceaux de<br/>gomme Mentos Pure Fresh!",
      winnerText: "Gageons que quelqu’un va se faire un tas d’amis.",
    },

    steps: {
      firstStepTitle: "Étape 1 :",
      firstStepText: "Trouve un yéti",
      secondStepTitle: "Étape 2 :",
      secondStepText: "Prends une photo",
      thirdStepTitle: "Étape 3 :",
      thirdStepText: "Partage-la sur Instagram avec #allofraicheur",
    },

    findAYeti: "Trouver un yéti",

    termsAndConditionsLabel: "Conditions",

    termsAndConditionsUrl: "/dist/reglement-de-participation.pdf",

    winnerName: "Ingrid",

    winnerBio: "Merci à Mentos de commanditer mon haleine fraîche pour le reste de ma carrière à McGill, et probablement pour le reste de ma vie. #allofraicheur<br/><br/>Merci beaucoup pour tout &#9786;",

    getToKnowUs: "Suis-nous",

    niceToMentosYou: "On s'appelle et on mentos",

    helloFreshness: "#allofraicheur",

    instagramFeedError: "Aucune image n'a pu être chargée pour le moment.",

    instagramFeedLoadMore: "En voir plus",

    footer: {
      contactUsLabel: "Contactez-nous",
      contactUsUrl: "http://www.mentos.ca/fr/contactez-nous",
      termesOfUseLabel: "Conditions d'utilisation",
      termesOfUseUrl: "http://www.mentos.ca/fr/conditions-dutilisation",
      faqLabel: "FAQ",
      faqUrl: "http://www.mentos.ca/fr/faq",
      countriesLabel: "Pays",
      countriesUrl: "http://countries.mentos.com",
    }
  }
};

const i18n = new VueI18n({ messages });

new Vue({
  i18n,

  el: "#contest-vue",

  components: {
    NavigationBar,
    Hero,
    YetiMap,
    InstagramFeed,
    SocialMedias,
    CtaButton
  },

  data: {
    lang: "en"
  },

  mounted() {
    VueEvents.$on("toggle-language", this.toggleLanguage);

    this.setDefaultLanguage();
  },

  methods: {
    toggleLanguage() {
      this.lang = (this.lang === "fr") ? "en" : "fr";
    },

    setDefaultLanguage() {
      var currentHostName = window.location.hostname;

      if (currentHostName == "allofraicheur.mentos.ca") {
        this.lang = "fr";
      }
      else {
        this.lang = "en";
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/vues/main.js